import { FC } from 'react'
import { useHistory } from 'react-router-dom'

import { BodyWrap } from '@pepper/ui'

import LiveProjectsList from './LiveProjectsList'
import AllItems from '../../AllItems/AllItems'

import styles from './_.module.css'
import { Helmet } from 'react-helmet'

export type ViewType = 'project' | 'items' | 'feedback'

const LiveProjects: FC = () => {
  const history = useHistory()

  const isItemsRoute = history.location.pathname === '/projects/items'

  return (
    <>
      <Helmet>
        <title>{isItemsRoute ? 'All Items' : 'All Projects'}</title>
      </Helmet>
      {isItemsRoute ? (
        <AllItems />
      ) : (
        <BodyWrap includeMaxWidthContainer={false}>
          <div className={styles.liveprojects}>
            <LiveProjectsList />
          </div>
        </BodyWrap>
      )}
    </>
  )
}

export default LiveProjects
